<template>
  <div class="mb-3">
    <global-wrapper :loading="loading" :loadingType="'avatar-three-line'" :loadingList="4" :scrollable="true">
      <visitor-recap-card :visitorData="visitorCardData" />
      <div class="vx-row mb-base">
        <div class="vx-col w-1/4">
          <visitor-todays-info :visitorData="visitorTodaysData" />
        </div>
        <div class="vx-col w-3/4">
          <visitor-recap-chart :chartData="visitorChartData" />
        </div>
      </div>
    </global-wrapper>
  </div>
</template>

<script>
import VisitorRecapCard from './sub-components/VisitorRecapCard.vue'
import VisitorTodaysInfo from './sub-components/VisitorTodaysInfo.vue'
import VisitorRecapChart from './sub-components/VisitorRecapChart.vue'
import Echo from "laravel-echo";
import io from "socket.io-client";
import Axios from "axios";

export default {
  components: {
    VisitorRecapCard,
    VisitorTodaysInfo,
    VisitorRecapChart
  },
  data() {
    return {
      loading: true,
      visitorCardData: {},
      visitorChartData: {},
      visitorTodaysData: {},
      echo: {
        token: '',
        deviceId: ''
      }
    }
  },
  mounted() {
    this.getVisitorRecapData();
    this.getVisitorTodaysInfoData();
    // this.initEcho();
  },
  methods: {
    async getVisitorRecapData(){
      const res = await this.$httpMpp.get('/app/statistic/visitor-recap-data');
      let responseData = res.data.data;
      this.visitorCardData = responseData.card;
      this.visitorChartData = responseData.chart;
      this.loading = false;
    },
    async getVisitorTodaysInfoData(){
      const res = await this.$httpMpp.get('/app/statistic/visitor-todays-info');
      this.visitorTodaysData = res.data.data;
      this.loading = false;
    },
    initEcho(){
      this.loginDevice();
    },
    loginDevice(){
      this.$httpMpp.post(`/device/auth`, { device_id : '123456' })
      .then((response) => {
        this.echo.token = response.data.data.token;
        this.echo.deviceId = response.data.data.id;
        this.listenEcho();
      })
      .catch((e) => {
        this.parseError(e);
      });
    },
    listenEcho(){
      this.echo = new Echo({
        broadcaster: "socket.io",
        host: process.env.VUE_APP_MPP_API_ECHO_SERVER,
        client: io,
        auth: {
          headers: {
            Authorization: `Bearer ${this.echo.token}`,
          },
        },
      });
      this.axios = Axios.create({
        baseURL: process.env.VUE_APP_MPP_API,
        headers: {
          Authorization: `Bearer ${this.echo.token}`,
        },
      });
      
      this.echo.private(`Device.Display.${this.echo.deviceId}`)
      .listen(".OnCallQueueEvent", () => {
        this.getVisitorRecapData();
        this.getVisitorTodaysInfoData();
      });
    }
  }
}
</script>